module.exports = __webpack_public_path__ + "media/images/members/jose_montero_reguera-99de9741dd5018c3772d28ff5bb0488d.jpg";